import React, { useEffect } from "react";
import * as S from "./RTCBanner.styles";
import AltSlick from "../../../../components/AltSlick/AltSlick";
import { useSelector, useDispatch } from "react-redux";
import { rtcHomeBannerSelector } from "../../../../containers/Home/redux/selectors";
import { fetchRTCHomeBanner } from '../../../../containers/Home/redux/thunks';
import { pushCtaOmniEvents } from '../../../../utils/PushEvents/Omniture/clickEvents'
import { CTA_TYPE } from '../../../../utils/PushEvents/Omniture/utils' 

const onClickHelper = (redirect_url) => {
    pushCtaOmniEvents('Govt_Bus', CTA_TYPE.IMAGES, 'Dweb_home', 'SEO');
    if (redirect_url) { window.open(redirect_url); }
}

const RTCBanner = (props) => {
    const dispatch = useDispatch();
    const { rtcHomeBanner } = useSelector(rtcHomeBannerSelector);
    const { data = [] } = rtcHomeBanner;
    const renderRTCHomeBanner = Boolean(rtcHomeBanner && data && data.length);

    const settings = {
        dots: false,
        infinite: false,
        speed: 1000,
        slidesToShow: 8,
        slidesToScroll: 1,
        arrows: true,
    };

    useEffect(() => {
        dispatch(fetchRTCHomeBanner());
        return () => { };
    }, []);

    return (<>
        {renderRTCHomeBanner ?
            <S.GovtBusContainer>
                <S.BusHeading>Government Buses</S.BusHeading>
                <S.GovtBusWrapper>
                    <AltSlick {...settings}>
                        {data.map((item, index) => {
                            const { logo_url, abb, name, redirect_url = "" } = item;
                            return (
                                <S.BusContainer onClick={() => {
                                    onClickHelper(redirect_url)
                                }}>
                                    <S.BusImgContainer>
                                        <S.BusImgWrap>
                                            <S.BusImg src={logo_url} />
                                        </S.BusImgWrap>
                                        <S.BusTxtWrap>
                                            <S.BusTxt>{abb}</S.BusTxt>
                                        </S.BusTxtWrap>
                                    </S.BusImgContainer>
                                    <S.BusName>{name} </S.BusName>
                                </S.BusContainer>
                            );
                        })}
                    </AltSlick>
                </S.GovtBusWrapper>
            </S.GovtBusContainer>
            : <></>}
    </>);
}

export default RTCBanner;
